export const environment = {
    production: false,
    RZP_KEY: 'rzp_test_LDC50yRioTgPPK'
  };